define('headerUsersView',[
  'module',
  'marionette',
  'underscore',
  'headerUsersListView',
  'template!headerUsersView'
], function (
  Module,
  Marionette,
  _,
  ListView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl, 
    className: 'header-users-view', 

    ui: {
      icon: '.icon',
      loader: '.loader-2'
    },

    events: {
      'click': 'onCollapse'
    },

    regions: {
      listRegion: '.list-region'
    },

    onRender: function () {         
      this.listView = new ListView({});
      this.getRegion('listRegion').show(this.listView);
    },   

    onCollapse: function (event) {
      event.stopPropagation();
    
      if (this.listView.isVisible())
        this.listView.close();
      else {    
        this.trigger('closeAllPopups');
      
        this.ui.icon.hide();
        this.ui.loader.show();

        this.listView.open().done(_.bind(function () {
          this.ui.icon.show();
          this.ui.loader.hide();
        }, this));      
      }
    },

    close: function () {    
      this.listView.close();
    }
  });
});
